import { colors } from '@keen.io/colors';
export var getIconColor = function (disabled) {
    return disabled ? colors.white[300] : colors.blue[100];
};
